import  axiosI  from '../Service/service';
import { ADD_POST, GET_POST, DELETE_POST,REFETCH_POSTS,ENABLE,DISABLE,UPDATE_POST,EMPTY_LIST } from './actionTypes';
import * as constants from '../Constants';

export const addPost=(dictionary)=>{
    return (dispatch => {
        dispatch({type: ENABLE, payload: true});
        return axiosI.post(constants.API.addFeedByUserApi,dictionary,{headers:{'Content-Type':'application/json'}}).then(({data})=>{
          if(data.results.ResponseCode){
             axiosI.post(constants.API.addUserPointApi,{PointType:1,Remark:data.results.FeedDetail.FeedId,UserId:dictionary.UserId}).then(()=>{
              console.log('data',data)
            })
          }
        dispatch({
          type: ADD_POST,
          payload: {postComment:dictionary.PostComment,image:dictionary.Image,isImage:dictionary.isImage,FeedId:data.results.FeedDetail.FeedId}
        });
        dispatch({type: DISABLE, payload: false});
      })
    })
};

export const fetchPost=(data)=>{
  return (dispatch => {
    dispatch({type:REFETCH_POSTS});
    return axiosI.get(`${constants.API.getUserOwnLocalFeedByFeedTypeApi}/${data.UserId}/${data.UserId}/${data.Latitude}/${data.Longitude}/0/ProfileFeed/${data.pageNo}/15/${data.delCount}`).then(({data})=>{
      dispatch({
        type: GET_POST,
        payload: data.results
      });
    })
  })
};
export const deletePost=(deletePostFeedId)=>{
    return (dispatch => {
      dispatch({type: ENABLE, payload: true});
        return axiosI.post(constants.API.deleteUserOwnFeedApi,deletePostFeedId).then(()=>{
            dispatch({
                type: DELETE_POST,
                payload: deletePostFeedId
            });
          dispatch({type: DISABLE, payload: false});
        })
    })
};
export const updatePost=(updatedPost)=>{
  return (dispatch => {
    dispatch({type: ENABLE, payload: true});
    return axiosI.post(constants.API.updateFeedByUserApi,updatedPost).then(({data})=>{
      dispatch({
        type: UPDATE_POST,
        payload: {postComment:updatedPost.PostComment,FeedId:data.results.FeedDetail.FeedId}
      });
      dispatch({type: DISABLE, payload: false});
      return "";
    })
  })
};
export const EmptyFeedList=()=>{
  return (dispatch => {
      dispatch({
        type: EMPTY_LIST
      });
    })
};